module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-47-min.14b3ff80.jpg";